import PropTypes from 'prop-types';
import { useStyles } from '../../../pages/NewOrder/styles';
import {Badge, DialogContent} from '@mui/material';
import {ItemDialog} from "../../../pages/Selling/Widgets/AddItemWidget/style";

export default function MenuItemDetailsDialog({ item , onClick, open, onClose}) {
    const { name, cover, rate,description, colors, status, priceSale , item_code, projected_qty} = item;
    const classes = useStyles();


    const handleClick = () => {
        // Call the provided onClick function when the component is clicked
        if (onClick) {
            onClick(item);
        }
    };

    const handleClose = () => {
        console.log("Handle close")
        // reset()
        if (onClose) {
            onClose();
        }
    }

    return (
        <ItemDialog className={classes.DialogWrap} onClose={() => { handleClose() }} open={open}>
            <DialogContent>
                <div className={classes.itemCardEnabled} onClick={handleClick} >
                    <div className='Item'>
                        <div src={cover} className={'Img'} style={{
                            backgroundImage: `url(${cover})`,
                            "width": "290px",
                            "height": "269.38px",
                            "borderRadius": "8px",
                            "backgroundRepeat": "no-repeat",
                            "backgroundPosition": "center",
                            "backgroundSize": "cover",
                        }}>
                        </div>
                        <div className={'MainDetails'} >
                            <div className={'Name'} >{name}</div>
                            <div className="Description">{description}</div>
                            <div className={'SubDetails'}>
                                <div className={'Price'} >Price: {rate}</div>
                            </div>
                        </div>
                    </div>

                </div>
            </DialogContent>
        </ItemDialog>
    );
}
